import { mergeMap } from 'rxjs/operators';
import get from 'lodash.get';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';

const makeApiCallWithIds = (job) => {
  const { model, ids } = job;
  const note = get(model, 'note');
  const request = {
    filter: {
      fulfillmentPlanId: ids,
    },
    note,
  };

  return Api.bulkUpdateAddNote(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;
  const note = get(model, 'note');
  const request = {
    bulkUpdateJobGuid,
    note,
  };

  return Api.bulkAddNoteUpdate(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const addNote = {
  id: 'add-note',

  applicableBulkActions: [BulkActions.addNote, BulkActions.customFieldOne, BulkActions.customFieldTwo, BulkActions.customFieldThree],

  handler: (job) => {
    const {
      jobData: { bulkUpdateJobGuid },
    } = job;

    const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;

    return makeApiCall$(job);
  },
};
